import {Duration} from "../common/duration";
import {EmployeeProfile} from "../common/employee-profile";
import {AssetView} from "./asset";
import {AssetCategory} from "./asset-category";
import {AuditInfo} from "../common/audit-info";

export enum AssetAllocationStatus {
    REQUESTED = "REQUESTED",
    ALLOCATED = "ALLOCATED",
    RETURNED = "RETURNED",
    REQUEST_CANCELLED = "REQUEST_CANCELLED",
    REQUEST_REJECTED = "REQUEST_REJECTED",
    MISSING = "MISSING",
    REQUEST_ACCEPTED = "REQUEST_ACCEPTED"
}

export type AssetAllocationSortField =
    | 'ASSIGNED_DATE'
    | 'EXPECTED_RETURN_DATE'
    | 'RETURNED_DATE'
    | 'CREATED_ON'
    | 'UPDATED_ON';

export interface AssetAllocation {
    categoryId: string;
    assetId: string;
    expectedReturnDate?: Date;
    adminRemarks?: string;
    status: AssetAllocationStatus;
}

// Search field parameters to be send in the "Asset Allocation Search API"
export interface AssetAllocationSearch {
    employeeId?: string;
    includeReturned?: boolean;
    assetCode?: string;
    assetId?: string;
    categoryId?: string;
    categoryName?: string;
    status?: AssetAllocationStatus[];
    assignedDateRange?: Duration;
    expectedReturnDateRange?: Duration;
    overdueAssets?: boolean;
    employeeName?: string;
    sortDirection?: 'ASC' | 'DESC';
    sortBy?: AssetAllocationSortField;
}

// "Asset Allocation Search API" response data
export interface AssetAllocationSearchView {
    id?: string;
    asset?: AssetView;
    employeeProfile?: EmployeeProfile;
    assetCategory?: AssetCategory;
    assignedBy?: string;
    assignedDate?: Date;
    returnedDate?: Date;
    expectedReturnDate?: Date;
    renewalDate?: Date;
    employeeRemarks?: string;
    adminRemarks?: string;
    status?: AssetAllocationStatus;
    auditInfo?: AuditInfo;
}

export interface AssetAllocationAudit {
    assetAllocationId?: string;
    asset?: string;
    employee?: string;
    status?: AssetAllocationStatus;
    auditInfo?: AuditInfo;
}